import { FormFieldTypes } from "../../../components/forms/libs/data/formFieldType";
const initState = {
    eventname: null,
  };
export const EventFeedbackQuestionForm = {

    name: "EventFeedbackQuestionForm",
    initialState: initState,
    section: [
      {
        title: "EventFeedbackQuestionForm",
        row: {},
        style: {
          sectionStyle: "row verticle-form",
        },
        rowGroup: [
          {
            groupLabel: "EventFeedbackQuestionForm", // Group for contact fields
            style: {
              groupStyle: "col-lg-12 col-md-12 mb-2",
            },
            groupWrapper: <div className="row"></div>, // Wrapper HTML or Component
            fields: [
              {
                id: "eventName",
                label: "Search by Event Name",
                Field_Name: "Search by Event Name",
                fieldType: FormFieldTypes.INPUT,
                dataField: "eventName",
                fieldSetting: {
                  allowSpace: true,
                },
                style: {
                  containerCss: "col-lg-4 mb-2 validation-left-0 mb-2",
                },
              },
            ],
          },
        ],
      },
    ],
  }